// Classes do AdminLTE para as telas da área logada. Toda tela com menu
// lateral chama esta função ao abrir, e o menu começa sempre fechado
// (sidebar-collapse); quem quiser abre pelo botão ☰ do topo. Não montar
// document.body.className à mão nas telas: foi assim que parte delas
// passou a abrir com o menu aberto.
// Último modo usado neste navegador, que sobrevive ao "Sair": é o que a tela
// de login usa, já que ali ninguém entrou ainda (pages/Login)
export const DARK_MODE_KEY = 'darkMode';

export const lastDarkMode = () => {
  try {
    return localStorage.getItem(DARK_MODE_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const rememberDarkMode = dark => {
  try {
    localStorage.setItem(DARK_MODE_KEY, dark ? '1' : '0');
  } catch (e) {
    // sem localStorage, o login só abre claro
  }
};

// Modo escuro: preferência do usuário logado (users.dark_mode), lida do
// usuário guardado no localStorage. O botão da lua (components/NavbarTools)
// troca a classe na hora, pelo UserProvider.
const savedDarkMode = () => {
  try {
    return !!JSON.parse(localStorage.getItem('authenticatedUser'))?.dark_mode;
  } catch (e) {
    return false;
  }
};

export const applyAdminLayout = ({ navbarFixed = false } = {}) => {
  document.body.className = [
    'hold-transition sidebar-mini sidebar-collapse',
    navbarFixed ? 'layout-navbar-fixed' : '',
    'layout-fixed',
    savedDarkMode() ? 'dark-mode' : '',
  ]
    .filter(Boolean)
    .join(' ');
  document.getElementById('root').className = 'wrapper';
};

export default applyAdminLayout;
